// 종목 관련 타입 정의

export interface Sport {
  sport_id: number;
  sport_name: string;      // 영문 코드 (soccer, baseball, etc.)
  sport_name_kr: string;   // 한글명 (축구, 야구, etc.)
}

export interface SportOption {
  value: string;   // sport_name
  label: string;   // sport_name_kr
}

// 종목 데이터 변환 유틸리티
export const sportToOption = (sport: Sport): SportOption => ({
  value: sport.sport_name,
  label: sport.sport_name_kr
});

export const sportsToOptions = (sports: Sport[]): SportOption[] =>
  sports.map(sportToOption);

// 종목명 한글 변환 (fallback용)
export const getSportLabel = (
  sportName: string,
  sports: Sport[]
): string => {
  const sport = sports.find(s => s.sport_name === sportName);
  return sport?.sport_name_kr || sportName;
};

// 종목명 영문 변환
export const getSportName = (
  sportNameKr: string,
  sports: Sport[]
): string => {
  const sport = sports.find(s => s.sport_name_kr === sportNameKr);
  return sport?.sport_name || sportNameKr;
};
